import React from 'react';
// background
import WomanImg from '../img/woman_hero.png'
import { Link } from 'react-router-dom';

const Hero = () => {
  return <section
  className='flex justify-center bg-pink-200 h-[800px] bg-hero bg-no-repeat bg-cover bg-center py-24'
  >
    <div className='container mx-auto flex justify-around'>
      {/* text */}
      <div className='flex flex-col justify-center'>
        {/* preTitle */}
        <div className='font-semibold flex items-center uppercase'>
          <span className='w-10 h-[2px] bg-red-500 mr-4'></span>New trend
        </div>
        <h1 className='text-[70px] leading-[1.1] font-light mb-4'>AUTUMN SALE STYLISH <br />
        <span className='font-semibold'>CLOTHES</span>
        </h1>
        <p className='text-[15px] leading-normal w-full md:w-[90%]'>"Discover your style at our online fashion destination! Browse trendy outfits, timeless classics, and accessories galore. Elevate your wardrobe effortlessly with our curated collection. Shop now!"</p>
        {/* button */}
        <button type="button" className='px-5 py-3 text-sm bg-black w-full md:w-4/12 rounded-full text-white my-1'>Start Shopping</button>
      </div>
      {/* image */}
      <div className='hidden lg:block'>
       <img src={WomanImg} alt="" />
      </div>
    </div>
  </section>;
};

export default Hero;
